import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Category } from 'src/app/stores/stores';

@Component({
  selector: 'app-default-category-tiles',
  templateUrl: './default-category-tiles.component.html',
  styleUrls: ['./default-category-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultCategoryTilesComponent implements AfterViewInit {
  @Input() topLevelCategories: Category[];
  @Input() hasOtherTopLevelCategories: boolean;
  @Input() selectedTopCat: number;
  @Input() gutterBottom: boolean = false;

  @Output() categorySelected = new EventEmitter<number>();
  @Output() viewToggle = new EventEmitter<void>();

  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLDivElement>;

  isOverflowing = false;

  constructor(
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.updateOverflowState();
  }

  onSelectTopLevelCategory(categoryId: number) {
    this.categorySelected.emit(categoryId);
  }

  onViewToggle() {
    this.viewToggle.emit();
  }

  onScroll() {
    this.updateOverflowState();
  }

  private updateOverflowState() {
    const el = this.scrollContainer?.nativeElement;
    if (!el) return;
    this.isOverflowing = el.scrollWidth > el.clientWidth;
    this.cdr.markForCheck();
  }

  getBackgroundImage(url: string) {
    if (url && /^https?:\/\//.test(url)) {
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`);
    }
    return '';
  }

  @HostListener('window:resize')
  onResize() {
    this.updateOverflowState();
  }

  trackByCategoryId(_index: number, category: Category): number {
    return category.categoryId;
  }
}
